module.exports = __webpack_public_path__ + "57e8c9da62fec47beb4e60e744f0c1d8.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/sports-clubhouse.png
// module id = 599
// module chunks = 0